import { Add, Save } from "@mui/icons-material";
import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  Fade,
  Grid,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { GetAllPartesList } from "../../../../hooks/getPartesList";
import { GetAllClientesList } from "../../../../hooks/getListClientes";
import { useLoading } from "../../../../components/Loading/useLoading";
import { CreateItemsPlan } from "../../../../hooks/planProductivo";
import { useSnackbar } from "notistack";

const style = {
  position: "absolute",
  top: "45%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1200,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "flex",
  justifyContent: "center",
  maxHeight: "80vh",
  overflowY: "scroll",
};

export const ModalAgregarItem = ({
  open,
  handleClose,
  almaSelected,
  lastPriority,
}) => {
  const { setAppLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const { createItemsPlanMutation } = CreateItemsPlan();
  const { getAllPartesListMutation } = GetAllPartesList();
  const { getAllClientesListMutation } = GetAllClientesList();
  const [partes, setPartes] = useState([]);
  const [newItems, setNewItems] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [priorityCounter, setPriorityCounter] = useState(0);

  useEffect(() => {
    getClientes();
    getPartes();
  }, []);
  useEffect(() => {
    if (open) {
      console.log("Última prioridad pasada al modal:", lastPriority);
      setPriorityCounter(lastPriority + 1);
    }
  }, [open, lastPriority]);

  const getClientes = () => {
    getAllClientesListMutation(
      {},
      {
        onSuccess: (data) => {
          data.sort((a, b) => {
            return a.label.localeCompare(b.label);
          });
          setClientes(data);
        },
        onError: (error) => {
          console.log(error);
        },
      },
    );
  };
  const getPartes = () => {
    setAppLoading(true);
    getAllPartesListMutation(
      {},
      {
        onSuccess: (data) => {
          setPartes(data);
        },
        onError: (error) => {
          console.log(error);
        },
        onSettled: () => {
          setAppLoading(false);
        },
      },
    );
  };

  const handleSave = () => {
    if (newItems.length === 0) {
      handleClose();
      return;
    }
    setAppLoading(true);
    createItemsPlanMutation(newItems, {
      onSuccess: (data) => {
        enqueueSnackbar("Items agregados exitosamente", {
          autoHideDuration: 2000,
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onError: (error) => {
        enqueueSnackbar("Error al agregar items", {
          autoHideDuration: 2000,
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onSettled: () => {
        setAppLoading(false);
        handleClose();
      },
    });
  };

  const handleAddDistribution = () => {
    console.log("Agregando nuevo item con prioridad:", almaSelected, priorityCounter);
    let newDistribution = {
      pp_alma_id: almaSelected,
      emp_id: null,
      part_id: null,
      pp_alma_item_prioridad: priorityCounter,
      pp_alma_item_racks: null,
      pp_alma_item_done: 0,
    };
    let distributionData = [...newItems, newDistribution];
    setNewItems(distributionData);
    setPriorityCounter(priorityCounter + 1);
  };
  const handleChangeDistribution = (value, name, index) => {
    let newDistribution = [...newItems];
    newDistribution[index][name] = value;
    setNewItems(newDistribution);
  };
  const handleKeyUp = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              className="center_item"
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              <Typography component="span">Agregar Item</Typography>
              <div style={{ display: "flex", gap: "10px" }}>
                <Button
                  variant="contained"
                  onClick={() => handleSave()}
                  endIcon={<Save />}
                  sx={{
                    background: "#575E3B",
                    borderRadius: 2,
                    px: 4,
                    py: 1.2,
                    fontWeight: 700,
                    fontSize: 14,
                    textTransform: "none",
                    boxShadow: `0 4px 14px #575E3B44`,
                    "&:hover": {
                      background: "#40442d",
                      boxShadow: `0 6px 18px #575E3B55`,
                    },
                  }}
                >
                  Guardar
                </Button>
                <Button
                  variant="contained"
                  onClick={() => handleAddDistribution()}
                  endIcon={<Add />}
                  sx={{
                    background: "#575E3B",
                    borderRadius: 2,
                    px: 4,
                    py: 1.2,
                    fontWeight: 700,
                    fontSize: 14,
                    textTransform: "none",
                    boxShadow: `0 4px 14px #575E3B44`,
                    "&:hover": {
                      background: "#40442d",
                      boxShadow: `0 6px 18px #575E3B55`,
                    },
                  }}
                >
                  Nuevo registro
                </Button>
              </div>
            </Grid>
            {newItems.map((item, index) => (
              <Grid item xs={12} className="center_item">
                <Grid container spacing={0}>
                  <Grid item xs={2} className="center_item" sx={{ p: 1 }}>
                    <TextField
                      id="prioridad_racks"
                      label="Prioridad"
                      name="prioridad_racks"
                      fullWidth
                      size="small"
                      value={item.pp_alma_item_prioridad}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={5} className="center_item" sx={{ p: 1 }}>
                    <Autocomplete
                      fullWidth
                      id="emp_id"
                      getOptionLabel={(opcion) => opcion.label}
                      filterSelectedOptions
                      options={clientes}
                      onKeyDown={handleKeyUp}
                      onChange={(e, newValue) =>
                        handleChangeDistribution(
                          newValue?.value || null,
                          "emp_id",
                          index,
                        )
                      }
                      renderOption={(props, option) => (
                        <Box {...props} key={option?.value}>
                          {option.label}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Cliente"
                          size="small"
                          fullWidth
                          required
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={5} className="center_item" sx={{ p: 1 }}>
                    <Autocomplete
                      fullWidth
                      id="part_id"
                      getOptionLabel={(opcion) =>
                        opcion?.codigo !== undefined
                          ? `${opcion?.label} / ${opcion?.codigo} / ${opcion?.codigo_salida} / ${opcion?.codigo_alterno}`
                          : opcion?.label
                      }
                      filterSelectedOptions
                      options={partes.filter(
                        (part) => part.emp_id === item.emp_id,
                      )}
                      disabled={!item.emp_id}
                      onKeyDown={handleKeyUp}
                      onChange={(e, newValue) =>
                        handleChangeDistribution(
                          newValue?.value || null,
                          "part_id",
                          index,
                        )
                      }
                      renderOption={(props, option) => (
                        <Box {...props} key={option?.value}>
                          {option?.codigo !== undefined ? (
                            option?.codigo
                          ) : (
                            <></>
                          )}{" "}
                          /
                          {option?.codigo_salida !== undefined ? (
                            option?.codigo_salida
                          ) : (
                            <></>
                          )}{" "}
                          /
                          {option?.codigo_alterno !== undefined ? (
                            option?.codigo_alterno
                          ) : (
                            <></>
                          )}{" "}
                          / {option?.label}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Parte"
                          size="small"
                          fullWidth
                          required
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};
